import { createTheme } from "@mui/material/styles";
import { BRAND as FALLBACK_BRAND } from "../brand/config";

export { BRAND, brand, themeColor } from "../brand/config";

export function createAppTheme(colors = FALLBACK_BRAND) {
  const c = colors || FALLBACK_BRAND;
  return createTheme({
    palette: {
      primary: {
        main: c.primary,
        dark: c.primaryDark || c.secondary || c.primary,
        light: c.primaryLight || c.primary,
      },
      secondary: {
        main: c.accent || c.secondary || c.primary,
      },
      success: {
        main: c.accent || "#7BC043",
      },
      background: {
        default: "#f5f5f5",
        paper: "#ffffff",
      },
      text: {
        primary: "#212121",
        secondary: "#757575",
        disabled: "#9e9e9e",
      },
      divider: "#E0E0E0",
      error: {
        main: "#d32f2f",
      },
    },
    typography: {
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
      ].join(","),
      h1: { fontWeight: 700 },
      h2: { fontWeight: 700 },
      h3: { fontWeight: 700 },
      h4: { fontWeight: 600 },
      h5: { fontWeight: 600 },
      h6: { fontWeight: 600 },
    },
    shape: {
      borderRadius: 8,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            borderRadius: 8,
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: 12,
          },
        },
      },
    },
  });
}

/** Static default theme (tests / Storybook / before boot). */
export const appTheme = createAppTheme(FALLBACK_BRAND);

export default appTheme;
